export default {
  namespaced: true,
  actions: {
    create({ commit }, affiliation) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.post('admin/affiliations', { affiliation })
    },
    destroy({ commit }, id) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.delete(`admin/affiliations/${id}`)
    }
  }
}
